// toggleBlocks.js

/*eslint-disable*/
export function initToggleBlocks(containerSelector = 'body') {
    const container = document.querySelector(containerSelector);
    if (!container) return;
  
    const toggleBlocks = container.querySelectorAll('.toggle-text-block');
  
    toggleBlocks.forEach(block => {
      const shortText = block.querySelector('.short-text');
      const fullText = block.querySelector('.full-text');
      const button = block.querySelector('.toggle-button');
      const buttonSpan = button.querySelector('span');
  
      if (!shortText || !fullText || !button) return;
  
      button.addEventListener('click', () => {
        const isCollapsed = fullText.style.display === 'none';
  
        fullText.style.display = isCollapsed ? 'block' : 'none';
        shortText.style.display = isCollapsed ? 'none' : 'block';
  
        buttonSpan.textContent = isCollapsed
          ? button.dataset.showLess
          : button.dataset.showMore;

      });
    });
  }
  